import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

if (!rootElement) {
  console.error('Failed to find root element');
} else {
  try {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error('Error initializing app:', error);
    // Fallback rendering if Firebase fails
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <div style={{ padding: '20px', fontFamily: 'Arial' }}>
        <h1>Tee It Up</h1>
        <p>We're experiencing some technical difficulties. Please try refreshing the page.</p>
        <p>If the problem persists, please contact support.</p>
      </div>
    );
  }
}

reportWebVitals(); 